import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { Neon } from '../neon';

type ProjectDetailsPageTemplateTypes = {
  documentTitle: string;
  title: ReactNode;
  breadCrumbs?: ReactNode;
  tabs?: ReactNode;
  subText?: ReactNode;
};
export const PageHeader = styled(Page.Header)`
  padding: 0px !important;
  padding-left: 8px !important;
`;
export const ProjectDetailsPageTemplate: FC<ProjectDetailsPageTemplateTypes> =
  ({ documentTitle, title, tabs, children }) => {
    return (
      <Neon
        documentTitle={documentTitle}
        title={title}
        tabs={tabs}
        actions={{}}
        content={children}
      />
    );
  };
